import React, { useState } from "react";
import { useLanguage } from "../LanguageProvider";
import PhoneInput from "./PhoneInput";

export default function KapcsolatForm() {
  const { dict } = useLanguage();
  const [form, setForm] = useState({ nev: "", email: "", phone: "", uzenet: "" });
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!form.nev || !form.email || !form.phone || !form.uzenet) {
      setError("Minden mező kitöltése kötelező!");
      return;
    }
    
    // Telefonszám validáció
    if (form.phone.length < 10) {
      setError("Kérjük, adjon meg egy érvényes telefonszámot!");
      return;
    }
    
    const payload = {
      name: form.nev,
      email: form.email,
      phone: form.phone,
      comment: form.uzenet,
      subject: 'Kapcsolatfelvétel a weboldalról',
    };
    // 1. Email küldés (marad)
    fetch('/send_offer.php', {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams(payload).toString(),
    })
      .then(res => res.json())
      .then(data => {
        if (data.success) setSent(true);
        else alert('Nem sikerült elküldeni az üzenetet. Próbáld újra!');
      })
      .catch(() => alert('Hiba történt az üzenetküldés közben.'));
    // 2. GHL kontakt létrehozása
    fetch('https://createghlcontact-thmhcq452a-uc.a.run.app', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        firstName: form.nev,
        email: form.email,
        phone: form.phone,
        message: form.uzenet,
        sourceType: 'contact',
      }),
    })
      .then(() => {/* Nem mutatunk hibát, ha csak ez sikertelen */})
      .catch(() => {/* Nem mutatunk hibát, ha csak ez sikertelen */});
  }

  if (sent) {
    return (
      <div className="py-12 flex flex-col items-center">
        <h2 className="text-2xl font-bold text-green-600 mb-2">{dict.contact?.successTitle || "Köszönjük!"}</h2>
        <p className="text-[#181818] mb-2">{dict.contact?.successMsg || "Hamarosan felvesszük Önnel a kapcsolatot."}</p>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="w-full max-w-xl mx-auto flex flex-col gap-6">
      <h2 className="text-2xl font-bold text-white mb-2 text-center">{dict.contact?.title || "Kapcsolatfelvétel"}</h2>
      <div className="flex flex-col gap-2">
        <label htmlFor="nev" className="text-white font-semibold">{dict.contact?.name || "Név"}</label>
        <input
          type="text"
          name="nev"
          id="nev"
          required
          value={form.nev}
          onChange={handleChange}
          className="rounded px-4 py-2 bg-white text-[#181818] border border-[#bbb] focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder={dict.contact?.placeholderName || "Teljes név"}
        />
      </div>
      <div className="flex flex-col gap-2">
        <label htmlFor="email" className="text-white font-semibold">{dict.contact?.email || "Email cím"}</label>
        <input
          type="email"
          name="email"
          id="email"
          required
          value={form.email}
          onChange={handleChange}
          className="rounded px-4 py-2 bg-white text-[#181818] border border-[#bbb] focus:outline-none focus:ring-2 focus:ring-primary"
          placeholder={dict.contact?.placeholderEmail || "email@pelda.hu"}
        />
      </div>
      <div className="flex flex-col gap-2">
        <label htmlFor="phone" className="text-white font-semibold">Telefonszám *</label>
        <PhoneInput
          name="phone"
          value={form.phone}
          onChange={handleChange}
          placeholder="30 123 4567"
          className="bg-white text-[#181818] border-[#bbb] focus:ring-primary"
          required
        />
      </div>
      <div className="flex flex-col gap-2">
        <label htmlFor="uzenet" className="text-white font-semibold">{dict.contact?.message || "Üzenet"}</label>
        <textarea
          name="uzenet"
          id="uzenet"
          required
          value={form.uzenet}
          onChange={handleChange}
          className="rounded px-4 py-2 bg-white text-[#181818] border border-[#bbb] focus:outline-none focus:ring-2 focus:ring-primary min-h-[100px]"
          placeholder={dict.contact?.placeholderMessage || "Írja meg üzenetét..."}
        />
      </div>
      {error && <div className="text-red-600 font-semibold text-center">{dict.contact?.error || error}</div>}
      <button type="submit" className="bg-primary hover:bg-hover text-white font-bold px-8 py-3 rounded-lg shadow-lg transition-all duration-200 text-lg mx-auto block text-center">{dict.contact?.submit || "Küldés"}</button>
    </form>
  );
}
